"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var SubscribtionConfirmComponent = /** @class */ (function () {
    function SubscribtionConfirmComponent() {
    }
    SubscribtionConfirmComponent.prototype.ngOnInit = function () {
    };
    return SubscribtionConfirmComponent;
}());
exports.SubscribtionConfirmComponent = SubscribtionConfirmComponent;
